<template>
  <div>
    <Loader v-if="$apolloData.loading" />
    <template v-if="$apolloData.queries.billing_information.loading" />

    <div class="step-container">
      <span class="step-title">Choose link type</span>
      <span class="step-subtitle">What is your objective for this link?</span>
      <div class="link-types-wrapper">
        <div class="link-types">
          <div
            @click="setLinkType('bio')"
            class="type"
            :class="{ active: isBio }"
          >
            <div class="type-container">
              <div class="type-icon">
                <i class="fa-light fa-circle-user"></i>
              </div>
              <span class="type-name">
                Bio
              </span>
            </div>
          </div>
          <div
            @click="setLinkType('playlist')"
            class="type"
            :class="{ active: isPlaylist }"
          >
            <div class="type-container">
              <div class="type-icon">
                <i class="fa-light fa-list-music"></i>
              </div>
              <span class="type-name">
                Playlist
              </span>
            </div>
          </div>
          <div
            @click="setLinkType('release')"
            class="type"
            :class="{ active: isRelease }"
          >
            <div class="type-container">
              <div class="type-icon">
                <i class="fa-light fa-music"></i>
              </div>
              <span class="type-name">
                Release
              </span>
            </div>
          </div>
          <div
            @click="setLinkType('pre-release')"
            class="type"
            :class="{ active: isPreRelease }"
          >
            <div class="type-container">
              <div class="type-icon">
                <i class="fa-light fa-bell-on"></i>
              </div>
              <span class="type-name">
                Pre-release
              </span>
            </div>
          </div>
          <div
            @click="setLinkType('podcast')"
            class="type"
            :class="{ active: isPodcast }"
          >
            <div class="type-container">
              <div class="type-icon">
                <i class="fa-light fa-podcast"></i>
              </div>
              <span class="type-name">
                Podcast
              </span>
            </div>
          </div>
          <div class="filler"></div>
          <div class="filler"></div>
          <div class="filler"></div>
        </div>
      </div>
      <div class="step-actions">
        <button @click="next()" :disabled="!selectedLinkType && !linkType" class="button-default big btn">
          <span>Next</span>
        </button>
      </div>
    </div>
    <div v-if="showUpgradeModal" class="modal">
      <div class="background-overlay"></div>
      <div class="upgrade-modal">
        <div @click="showUpgradeModal = false" class="modal-close">
          <CloseIcon />
        </div>
        <div class="modal-content">
          <div class="avatar">
            <img :src="artist.avatar_url" alt="" />
          </div>
          <div class="modal-title">
            <span>Unlock your music’s potential</span>
          </div>
          <div class="modal-subtitle">
            <span>
              Join the ranks of successful artists, labels, and agencies using
              Pro to supercharge their music marketing.
            </span>
          </div>
          <div class="details">
            <div class="title">How you can benefit from ArtistHub Pro...</div>
            <div class="list">
              <div class="item">
                <div class="icon">
                  <CheckIcon />
                </div>
                <div class="text">
                  <b>Presave Pro<!-- (ft. 1-Click Presaves) -->,</b>
                  <span>
                    the powerful solution to build pre-release hype and grow
                    engaged fanbases
                  </span>
                </div>
              </div>
              <div class="item">
                <div class="icon">
                  <CheckIcon />
                </div>
                <div class="text">
                  <b>Landing pages for releases, albums, and playlists</b>
                  <span>
                    to drive targeted and engaged fans to specific content
                  </span>
                </div>
              </div>
              <div class="item">
                <div class="icon">
                  <CheckIcon />
                </div>
                <div class="text">
                  <b>Email reminders and new music alerts </b>
                  <span>
                    for fans to increase release day streams and awareness
                  </span>
                </div>
              </div>
              <div class="item">
                <div class="icon">
                  <CheckIcon />
                </div>
                <div class="text">
                  <b>Auto-follow on Spotify</b>
                  <span>
                    to increase your Listener-to-Follower (LTF) rate
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="flex flex-col gap-1">
            <div class="price">
              <span class="price-value">
                <span class="transition" :class="prorate ? ' opacity-50 line-through' : null">
                  ${{ proPricing }}
                </span>
                <span v-if="prorate" class="pl-2 animate-fadeIn">${{ prorate }}</span>
              </span>
              <span class="price-period">/ mo</span>
            </div>
            <p v-if="prorate" class="text-xs font-semibold animate-fadeIn text-lilac">
              For your first month, on us! Then ${{ proPricing }}/mo
            </p>
          </div>

          <button :disabled="isUpgrading" @click="goToUpgrade" class="button-default big">
            <span v-if="!isUpgrading">
              Upgrade
              <span v-if="user.braintree_subscription_status == 'Trial'">trial</span>
              to Pro</span>
            <span v-else>Loading...</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import PrereleaseIcon from "../../../public/img/icons/Pre-release.svg";
import CloseIcon from "../../../public/img/icons/close.svg";
import CheckIcon from "../../../public/img/icons/check-2.svg";
import Loader from "@/components/Custom/Loader";
import {
  Q_PRO_PRICING,
  Q_ARTIST_SUBSCRIPTION_STATUS,
  M_UPGRADE_ARTIST_TRIAL_PLAN,
  Q_BILLING_INFORMATION,
  M_BRAINTREE_CHANGE_ARTIST_PLAN,
} from "@/graphql";

import moment from "moment";

export default {
  name: "CreateLinkWizardStepOne",
  components: {
    //PrereleaseIcon,
    CloseIcon,
    CheckIcon,
    Loader,
  },
  data() {
    return {
      selectedLinkType: null,
      showUpgradeModal: false,
      billingUser: {},
      artist: {},
      proPricing: null,
      prorate: null,
      subscription: {},
      isUpgrading: false,
    };
  },
  // query artist subscription status and billing user's subscription status using apollo
  apollo: {
    artist: {
      query: Q_ARTIST_SUBSCRIPTION_STATUS,
      variables() {
        return {
          artist_id: this.$store.getters.getArtist.id,
        };
      },
      update(data) {
        const { billing_user, ...artist } = data.artists_by_pk;
        this.billingUser = billing_user;
        return artist;
      },
    },
    proPricing: {
      query: Q_PRO_PRICING,
      variables() {
        return {
          user_id: this.user.id,
        };
      },
      skip() {
        return !this.user;
      },
      update(data) {
        return data.users_by_pk.pro_pricing;
      },
    },
    billing_information: {
      query: Q_BILLING_INFORMATION,
      client: "localClient",
      variables() {
        return {};
      },
      result({ data }) {
        if (!data.billing_information) return;
        const subscription = { ...data.billing_information };
        this.calculateProrate(subscription);
        this.subscription = subscription;
        // return subscription;
      },
    },
  },
  created() {
    // this.$store.commit("resetCreateLinkWizardData");
    if (this.linkType) {
      this.selectedLinkType = this.linkType;
    }
  },
  computed: {
    linkType() {
      const { link_type } = this.$store.state.createLinkWizardData;
      return link_type;
    },
    isRelease() {
      return [this.selectedLinkType, this.linkType].includes("release");
    },
    isPreRelease() {
      return [this.selectedLinkType, this.linkType].includes("pre-release");
    },
    isBio() {
      return [this.selectedLinkType, this.linkType].includes("bio");
    },
    isPlaylist() {
      return [this.selectedLinkType, this.linkType].includes("playlist");
    },
    isPodcast() {
      return [this.selectedLinkType, this.linkType].includes("podcast");
    },
    user() {
      return this.$store.getters.getUser;
    },
  },
  methods: {
    setLinkType(type) {
      if (
        this.artist.current_plan == "bio" &&
        !["agency", "family"].includes(this.billingUser.plan) &&
        type != "bio"
      ) {
        this.showUpgradeModal = true;
        return;
      }

      // console.log(type, this.selectedLinkType);
      if (type !== this.selectedLinkType) {
        this.selectedLinkType = type;
        this.$store.commit("resetCreateLinkWizardData");
        this.$store.commit("setCreateLinkWizardData", {
          link_type: type,
        });
      }
    },
    close() {
      this.$emit("close");
    },
    calculateProrate() {
      if (!this.subscription) return "";
      if (["agency", "family"].includes(this.user.plan)) return "";
      if (!this.subscription?.status) return "";
      if (this.subscription?.status === "Pending") return "";
      if (!this.subscription?.last_billing_date) return "";
      if (this.artist.active_plan.includes("pro")) return "";

      const start = moment(this.subscription.last_billing_date, "YYYY-MM-DD");
      const end = moment(this.subscription.next_billing_date, "YYYY-MM-DD");
      const today = moment();

      const proratedDays = end.diff(today, "days") + 1;

      const billingCycle = end.diff(start, "days");

      const total = this.proPricing - (this.subscription.discount || 0);
      const dailyRate = total / billingCycle;

      const final = (dailyRate * proratedDays).toFixed(2);

      if (!isNaN(final) && final > 0) {
        this.prorate = final;
      } else {
        this.prorate = null;
      }
    },
    next() {
      this.$emit("setStep", 2);
    },
    async goToUpgrade() {
      this.isUpgrading = true;
      try {
        if (this.user.braintree_subscription_status == "Trial") {
          await this.$apollo.mutate({
            client: "localClient",
            mutation: M_UPGRADE_ARTIST_TRIAL_PLAN,
            variables: {
              artist_id: this.artist.id,
            },
          });
        } else {
          await this.$apollo.mutate({
            client: "localClient",
            mutation: M_BRAINTREE_CHANGE_ARTIST_PLAN,
            variables: {
              artist_id: this.artist.id,
              selected_plan: "pro",
            },
          });
        }

        this.artist.current_plan = "pro";

        this.showUpgradeModal = false;

        this.isUpgrading = false;
        await this.$store.dispatch("snack", {
          text: "You've been upgraded to the pro plan!",
          autoDismiss: false,
        });
      } catch (error) {
        this.isUpgrading = false;
        setTimeout(async () => {
          await this.$store.dispatch("snack", {
            type: "error",
            text: "You need to update your billing information.",
          });
          this.$router.push("/billing");
        }, 10);

        console.error("Failed to upgrade plan:", error);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.step-container {
  padding-top: 60px;
  display: flex;
  flex-direction: column;

  .step-title {
    display: block;
    text-align: center;
    font-weight: bold;
    font-size: 30px;
    line-height: 42px;
    /* White */
    color: white;
    mix-blend-mode: normal;
    opacity: 0.9;
  }

  .step-subtitle {
    display: block;
    text-align: center;
    margin-top: 6px;
    /* 16/Regular */
    font-size: 16px;
    line-height: 24px;
    /* Text/type2 */
    color: $text-type-2;
  }

  .link-types {
    display: grid;
    grid-template: 1fr 1fr/1fr 1fr 1fr;
    grid-gap: 24px;
    width: fit-content;
    margin: 30px auto auto;

    .type {
      display: flex;
      align-items: center;
      width: 196px;
      height: 196px;
      padding: 2px;
      /* BG/type2 */
      background: $bg-type-2;
      border-radius: 10px;
      /* Shadow */
      box-shadow: 0px 50px 40px rgba(23, 18, 43, 0.3);

      &.active {
        background: linear-gradient(46.19deg, #9c27b0 5.66%, #9733ee 94.35%);

        .type-container {
          .type-icon {
            i {
              background: transparent;
              color: white;
              font-size: 80px;
            }
          }
        }
      }

      &.disabled {
        .type-container {
          cursor: default;

          .type-name,
          .type-icon {
            opacity: 0.5;
          }
        }
      }

      .type-container {
        cursor: pointer;
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: $bg-type-2;
        border-radius: 10px;
        overflow: visible;

        .badge {
          position: absolute;
          top: -8px;
          right: -24px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 4px 10px 5px;
          background: white;
          border-radius: 50px;

          span {
            /* 12/SemiBold */
            font-weight: 600;
            font-size: 12px;
            line-height: 15px;
            /* Purple 1 */
            color: $purple-type-1;
            mix-blend-mode: normal;
            opacity: 0.9;
          }
        }

        .type-icon {
          margin-top: 20px;

          i {
            background: linear-gradient(
              46.19deg,
              #12c2e9 5.66%,
              #c471ed 49.54%,
              #f64f59 94.35%
            );
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
            font-size: 80px;
          }
        }

        .type-name {
          margin-top: 15px;
          /* 16/SemiBold */
          font-weight: 600;
          font-size: 16px;
          line-height: 30px;
          /* White */
          color: white;
        }
      }
    }
  }

  .step-actions {
    width: 100%;
    display: flex;
    justify-content: end;
    margin-top: auto;
    padding-top: 50px;
    padding-bottom: 60px;
    .button-default {
      padding: 9px 40px;
    }
  }
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;

  .upgrade-modal {
    padding: 60px 0 0;
    width: 680px;
    z-index: 98;
    background: linear-gradient(241.25deg,
        rgba(41, 39, 85, 0.45) 4.4%,
        rgba(41, 39, 84, 0.85) 61.77%,
        rgba(27, 24, 66, 0.45) 119.94%);
    backdrop-filter: blur(23px);
    border-radius: 10px;

    .modal-close {
      cursor: pointer;
      position: absolute;
      top: 18px;
      right: 18px;
      display: flex;
      flex-direction: column;

      &:hover {
        svg {
          path {
            fill: white;
          }
        }

        .close-text {
          color: white;
        }
      }

      svg {
        width: 24px;

        path {
          fill: #8786ab;
        }
      }
    }

    .modal-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 40px;

      .avatar {
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 90px;
          height: 90px;
          border-radius: 50%;
        }
      }

      .modal-title {
        margin-top: 24px;
        color: #ffffff;
        font-weight: 700;
        font-size: 30px;
        line-height: 37px;
        text-align: center;
      }

      .modal-subtitle {
        margin-top: 30px;
        font-weight: 600;
        font-size: 20px;
        line-height: 24px;
        color: #ffffff;
        text-align: center;
      }

      .details {
        margin-top: 25px;

        .title {
          font-weight: 700;
          font-size: 16px;
          line-height: 20px;
          color: #ffffff;
        }

        .list {
          margin-top: 15px;

          .item {
            display: flex;
            margin-bottom: 10px;
            align-items: center;

            .icon {
              margin-right: 15px;
            }

            .text {
              font-size: 15px;
              line-height: 17px;
              color: #ffffffdd;

              b {
                color: #ffffff;
              }
            }
          }
        }
      }
    }

    .modal-footer {
      margin-top: 30px;
      padding: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid #b1afcd;

      .price {
        display: flex;
        align-items: flex-end;

        .price-value {
          font-weight: 700;
          font-size: 30px;
          line-height: 37px;
          color: #ffffff;
        }

        .price-period {
          font-weight: 400;
          font-size: 18px;
          line-height: 22px;
          color: #b1afcd;
          margin-left: 10px;
        }
      }

      button {
        padding: 9px 40px;
      }
    }
  }

  .background-overlay {
    z-index: 97;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: unset;
    /* Purple-dark */
    background: $purple-dark;
    opacity: 0.9;
    // webkit-backdrop-filter: blur(10px) !important;
    backdrop-filter: blur(10px) !important;
  }
}
@media (max-width: 768px) {
  .step-container {
    .link-types-wrapper {
      //   display: flex;
      //   justify-content: center;

      .link-types {
        .type {
          width: 159px;
          height: 159px;
        }
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        justify-content: center;
        .filler {
          width: 159px;
        }
      }
    }
  }
}
</style>
